export { createPresentationFromBaseTemplate } from './createPresentationFromBaseTemplate'
